<template>
  <b-modal
    id="modal-write-off-instrument"
    :title="$t('create_write-off')"
    cancel-variant="outline-secondary"
    :ok-title="$t('general.save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    size="xl"
    no-close-on-backdrop
    @ok="onSubmit"
    :ok-disabled="okStatus"
  >
    <b-table
      class="table-bordered border"
      :fields="fields"
      :items="GET_APPLICATIONS_INSTRUMENT_ID.objects"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(index)="{index}">
        <span>{{ index + 1 }}</span>
      </template>

      <template #cell(brigade)="props">
        <span v-if="props && props.item && props.item.brigade && props.item.brigade.title">{{ props.item.brigade.title }}</span>
      </template>

      <template #cell(titlePermishin)="data">
        <div class="d-flex justify-content-center">
            <!-- :disabled="data.item.isSaved" -->
            <b-button
            :disabled="write_off[data.index].count <= 0"
            size="sm"
            variant="primary"
            class="mr-50"
            @click="minusWriteOffAmount(data.index)"
          >
            <feather-icon
              icon="MinusIcon"
              size="15"
            />
          </b-button>


            <!-- :readonly="data.item.isSaved" -->
          <b-form-input
            v-model="write_off[data.index].count"
            min="0"
            :max="data.item.count2"
            @input="formatPrice(write_off[data.index].count, 'count', data.index)"
            onkeypress="return /[0-9,/.]/i.test(event.key)"
            style="width: 120px"
            placeholder=""
          />


            <!-- :disabled="data.item.isSaved" -->
          <b-button
            size="sm"
            variant="primary"
            class="ml-50"
            @click="addWriteOffAmount(data.index)"
          >
            <feather-icon
              icon="PlusIcon"
              size="15"
            />
          </b-button>
        </div>
        
      </template>


      <template #cell(remainder)="data">
        {{$_formatPriceMixin(data.item.remainder_in_local)}}
      </template>


      <template #cell(notEnough)="data">
        {{
          ((data.item.count - data.item.remainder_in_local) <= 0) 
            ? 0
            : (data.item.count - data.item.remainder_in_local)
        }}
      </template>



      <template #cell(actions)="data">
        <b-form-checkbox
          :disabled="disableCheckboxIfNeeded(data)"
          v-model="write_off[data.index].checked"
          :value="true"
          @input="onCheckProduct($event)"
          :unchecked-value="false"
        >
        </b-form-checkbox>
      </template>



    </b-table>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BTable,
  BFormSpinbutton,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import priceFormatMixin from '@/mixins/priceFormatMixin';

export default {
  components: {
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BRow,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BTable,
    BFormSpinbutton,
    BButton,
    BCard,
    BFormCheckbox,
  },
  mixins: [priceFormatMixin],
  data() {
    return {
      required,
      



      // ===============  PRIMARY_DATA_SECTION START ===============
      write_off: [{ count: 0 }],
      okStatus: true,
      fields: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: 'brigade',
          key: 'brigade',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: "reference.categoriya",
          key: "instrument.type.category.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "courses.type",
          key: "instrument.type.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "namee",
          key: "instrument.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "write-off_request",
          key: "titlePermishin",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
        },
        // {
        //   label: 'Стартовое количество',
        //   key: 'start_count',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },
        {
          label: "remaining_stock",
          key: "remainder",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
        },
        {
          label: "lacks",
          key: "notEnough",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "5%" },
        },
      ],
      // ==============  PRIMARY_DATA_SECTION END ===============





    }
  },
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATIONS_INSTRUMENT_ID",
    ]),


  },
  watch: {
    



    // ===============  PRIMARY_WATCHERS_SECTION START ===============
    GET_APPLICATIONS_INSTRUMENT_ID(newValue, oldValue) {
      this.write_off = JSON.parse(JSON.stringify(newValue.objects))
      this.write_off.forEach((elem) => {
        if((parseFloat(elem.count.toString().replace(/,/g, "")) 
        - parseFloat(elem.remainder.toString().replace(/,/g, "")) ) 
        <= 0 && (parseFloat(elem.count.toString().replace(/,/g, "")) != 0)){
          this.$set(elem, 'checked', true)
        } else {
          this.$set(elem, 'checked', false)
        }
      })
      this.GET_APPLICATIONS_INSTRUMENT_ID.objects.forEach((elem) => {
        elem.count2 = elem.count
      })
    },

    write_off: {
      handler: function (val, oldVal) {
        this.GET_APPLICATIONS_INSTRUMENT_ID.objects.forEach((elem, index) => {
          elem.count = parseFloat(this.write_off[index].count.toString().replace(/,/g, ""));
        });
      },
      deep: true,
    },
    // ===============  PRIMARY_WATCHERS_SECTION END ===============






  },
  async mounted() {
    


    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATIONS_INSTRUMENT_ID(this.$route.params.id)
        // ===============  PRIMARY_REQUESTS_SECTION END ===============
    this.checkAndDisableOKbuttonIfNeeded()

    setTimeout(() => {
      this.write_off.forEach((elem, index) => {
        this.formatPrice(elem.count, 'count', index)
      })
    }, 500)



  },
  methods: {
    ...mapActions("instruments", ["CREATE_WRITE_OFF_FOR_INSTRUMENT"]),
    ...mapActions("application", ["FETCH_APPLICATIONS_INSTRUMENT_ID"]),
    

    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit() {
      let instruments = [];
      let array = this.write_off.filter((elem) => elem.checked == true);
      array.forEach((elem) => {
        instruments.push({ instrument_id: elem.instrument.id, count: parseFloat(elem.count.toString().replace(/,/g, "")) })
      })
      await this.CREATE_WRITE_OFF_FOR_INSTRUMENT({
        requirement: this.$route.params.id,
        instruments: instruments,
      })
      this.$emit("refreshCall", true);
    },
    // ===============  ON_SUBMIT_SECTION END ===============






    // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type, index) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);
        

        if (type == "count") {
          this.write_off[index].count = currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============




    checkAndDisableOKbuttonIfNeeded(index){
      this.okStatus = true;
      if(this.write_off && this.write_off.length != 0){

        let counter = false;
        this.write_off.forEach((item) => {
          if( ( parseFloat(item.count.toString().replace(/,/g, "")) <= parseFloat(item.remainder_in_local.toString().replace(/,/g, "")) ) && (parseFloat(item.count.toString().replace(/,/g, "")) != 0)){
            this.okStatus = false
          }
          if( ( parseFloat(item.count.toString().replace(/,/g, "")) > parseFloat(item.remainder_in_local.toString().replace(/,/g, "")) ) && (parseFloat(item.count.toString().replace(/,/g, "")) != 0)){
            item.checked = false
          }

          if(item.checked){
            counter = true
          }
        })


        if(!counter){
          this.okStatus = true
        }

      }
    },






    disableCheckboxIfNeeded(data){
      


      if(!(data.item.count <= data.item.remainder_in_local) || (data.item.count == 0)){
        this.write_off[data.index].checked = false
        return true
      }else {
        return false
      }




      if(this.movement[data.index].remainder2 && this.movement[data.index].remainder2.sum_remainder){
        if(parseFloat(this.movement[data.index].count.toString().replace(/,/g, ""))
         <= parseFloat(this.movement[data.index].remainder2.sum_remainder.toString().replace(/,/g, ""))){
          return false          
        }else{

          this.goods = []
          this.movement.forEach((elem) => {
            if(elem.checked && elem.remainder2 && elem.remainder2.storage_id){
              this.goods.push({storage: elem.remainder2.storage_id, good_id: elem.good.id, count: parseFloat(elem.count.toString().replace(/,/g, ""))})
            }
          })
          
          this.$set(this.movement[data.index], 'checked', false)
          return true
        }
      }else{
        // this.movement[data.index].checked = false
        return true
      }
      
    },





    addWriteOffAmount(index){
      let a = parseFloat(this.write_off[index].count.toString().replace(/,/g, ""));
      a++;
      this.formatPrice(a, 'count', index)
      this.checkAndDisableOKbuttonIfNeeded(index)
    },


    minusWriteOffAmount(index){
      let a = parseFloat(this.write_off[index].count.toString().replace(/,/g, ""));
      a--;
      this.formatPrice(a, 'count', index)
    },



    onCheckProduct(value){
      this.checkAndDisableOKbuttonIfNeeded()
    }

    




  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}
</style>